import { render, staticRenderFns } from "./Ppclass.vue?vue&type=template&id=9b75129e&scoped=true&"
import script from "./Ppclass.vue?vue&type=script&lang=js&"
export * from "./Ppclass.vue?vue&type=script&lang=js&"
import style0 from "./Ppclass.vue?vue&type=style&index=0&id=9b75129e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b75129e",
  null
  
)

export default component.exports